"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var init_1 = __importDefault(require("./init"));

var Groups = __importStar(require("./groups"));

var Items = __importStar(require("./items"));

var Storage = __importStar(require("./storage"));

var Auth = __importStar(require("./auth"));

var FollowedGroups = __importStar(require("./followed-groups"));

var FollowedItems = __importStar(require("./followed-items"));

var Users = __importStar(require("./users"));

var PushTokens = __importStar(require("./push-tokens"));

var DeletedItems = __importStar(require("./deleted-items"));

exports.default = {
  Groups: Groups,
  FollowedGroups: FollowedGroups,
  FollowedItems: FollowedItems,
  Items: Items,
  Storage: Storage,
  Auth: Auth,
  Users: Users,
  PushTokens: PushTokens,
  DeletedItems: DeletedItems,
  setup: init_1.default
};